/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ActivityLogForRiskNodeActivityDto,
    ArrayOfAssessmentDto,
    CreateRiskDirectory,
    GetRisksParams,
    GetRisksRiskDirectoryIdInsightsParams,
    GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    GetRisksRiskDirectoryIdNodesParams,
    GetRisksRiskDirectoryIdParams,
    MissingRequiredColumnsDetails,
    NewRiskDirectoryNode,
    PatchRisksRiskDirectoryIdNodesBody,
    PostRisksRiskDirectoryIdAiInsightsParams,
    PostRisksRiskDirectoryIdCopyParams,
    RiskAiInsights,
    RiskDirectoryId,
    RiskDirectoryNodeWithDetailsDto,
    RiskDirectoryResource,
    RiskDirectoryResourceDto,
    RiskDirectorySuperNodeId,
    RiskDirectoryView,
    SimpleRiskDirectoryListDto,
    SingleRiskDirectoryNodeView,
    UpdatableRiskDirectory,
    UpdatedRiskDirectoryNode,
    UpdatedRiskDirectoryStructure,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getRisksRiskDirectoryIdNodesNodeId = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.get(`/api/risks/${riskDirectoryId}/nodes/${nodeId}`, options);
};

export const getGetRisksRiskDirectoryIdNodesNodeIdQueryKey = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId
) => {
    return [`/api/risks/${riskDirectoryId}/nodes/${nodeId}`] as const;
};

export const getGetRisksRiskDirectoryIdNodesNodeIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdNodesNodeIdQueryKey(riskDirectoryId, nodeId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdNodesNodeId(riskDirectoryId, nodeId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled:
            riskDirectoryId !== null &&
            riskDirectoryId !== undefined &&
            nodeId !== null &&
            nodeId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdNodesNodeIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>
>;
export type GetRisksRiskDirectoryIdNodesNodeIdQueryError = AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodesNodeId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodesNodeId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdNodesNodeIdQueryOptions(
        riskDirectoryId,
        nodeId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksRiskDirectoryIdNodesNodeIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdNodesNodeIdQueryKey(riskDirectoryId, nodeId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdNodesNodeId(riskDirectoryId, nodeId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdNodesNodeIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>
>;
export type GetRisksRiskDirectoryIdNodesNodeIdSuspenseQueryError =
    AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodesNodeIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodesNodeIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodesNodeId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetRisksRiskDirectoryIdNodesNodeIdSuspenseQueryOptions(
            riskDirectoryId,
            nodeId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteRisksRiskDirectoryIdNodesNodeId = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(
        `/api/risks/${riskDirectoryId}/nodes/${nodeId}`,
        options
    );
};

export const getDeleteRisksRiskDirectoryIdNodesNodeIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>,
        TError,
        { riskDirectoryId: RiskDirectoryId; nodeId: RiskDirectorySuperNodeId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; nodeId: RiskDirectorySuperNodeId },
    TContext
> => {
    const mutationKey = ["deleteRisksRiskDirectoryIdNodesNodeId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>,
        { riskDirectoryId: RiskDirectoryId; nodeId: RiskDirectorySuperNodeId }
    > = (props) => {
        const { riskDirectoryId, nodeId } = props ?? {};

        return deleteRisksRiskDirectoryIdNodesNodeId(
            riskDirectoryId,
            nodeId,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteRisksRiskDirectoryIdNodesNodeIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>
>;

export type DeleteRisksRiskDirectoryIdNodesNodeIdMutationError =
    AxiosError<unknown>;

export const useDeleteRisksRiskDirectoryIdNodesNodeId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                nodeId: RiskDirectorySuperNodeId;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryIdNodesNodeId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; nodeId: RiskDirectorySuperNodeId },
    TContext
> => {
    return useMutation(
        getDeleteRisksRiskDirectoryIdNodesNodeIdMutationOptions(options),
        queryClient
    );
};
export const patchRisksRiskDirectoryIdNodesNodeId = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    updatedRiskDirectoryNode: UpdatedRiskDirectoryNode,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SingleRiskDirectoryNodeView>> => {
    return axios.patch(
        `/api/risks/${riskDirectoryId}/nodes/${nodeId}`,
        updatedRiskDirectoryNode,
        options
    );
};

export const getPatchRisksRiskDirectoryIdNodesNodeIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>,
        TError,
        {
            riskDirectoryId: RiskDirectoryId;
            nodeId: RiskDirectorySuperNodeId;
            data: UpdatedRiskDirectoryNode;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        nodeId: RiskDirectorySuperNodeId;
        data: UpdatedRiskDirectoryNode;
    },
    TContext
> => {
    const mutationKey = ["patchRisksRiskDirectoryIdNodesNodeId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>,
        {
            riskDirectoryId: RiskDirectoryId;
            nodeId: RiskDirectorySuperNodeId;
            data: UpdatedRiskDirectoryNode;
        }
    > = (props) => {
        const { riskDirectoryId, nodeId, data } = props ?? {};

        return patchRisksRiskDirectoryIdNodesNodeId(
            riskDirectoryId,
            nodeId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchRisksRiskDirectoryIdNodesNodeIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>
>;
export type PatchRisksRiskDirectoryIdNodesNodeIdMutationBody =
    UpdatedRiskDirectoryNode;
export type PatchRisksRiskDirectoryIdNodesNodeIdMutationError =
    AxiosError<unknown>;

export const usePatchRisksRiskDirectoryIdNodesNodeId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                nodeId: RiskDirectorySuperNodeId;
                data: UpdatedRiskDirectoryNode;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodesNodeId>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        nodeId: RiskDirectorySuperNodeId;
        data: UpdatedRiskDirectoryNode;
    },
    TContext
> => {
    return useMutation(
        getPatchRisksRiskDirectoryIdNodesNodeIdMutationOptions(options),
        queryClient
    );
};
export const getRisksRiskDirectoryIdNodesNodeIdActivityLog = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ActivityLogForRiskNodeActivityDto>> => {
    return axios.get(
        `/api/risks/${riskDirectoryId}/nodes/${nodeId}/activity-log`,
        {
            paramsSerializer: { indexes: null },
            ...options,
            params: { ...params, ...options?.params },
        }
    );
};

export const getGetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryKey = (
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params?: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams
) => {
    return [
        `/api/risks/${riskDirectoryId}/nodes/${nodeId}/activity-log`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryKey(
            riskDirectoryId,
            nodeId,
            params
        );

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
        >
    > = ({ signal }) =>
        getRisksRiskDirectoryIdNodesNodeIdActivityLog(
            riskDirectoryId,
            nodeId,
            params,
            { signal, ...axiosOptions }
        );

    return {
        queryKey,
        queryFn,
        enabled:
            riskDirectoryId !== null &&
            riskDirectoryId !== undefined &&
            nodeId !== null &&
            nodeId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
        >,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
        >
    >;
export type GetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryError =
    AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLog<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLog<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                        >
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLog<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLog<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryOptions(
            riskDirectoryId,
            nodeId,
            params,
            options
        );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspenseQueryOptions =
    <
        TData = Awaited<
            ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
        >,
        TError = AxiosError<unknown>,
    >(
        riskDirectoryId: RiskDirectoryId,
        nodeId: RiskDirectorySuperNodeId,
        params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
        options?: {
            query?: Partial<
                UseSuspenseQueryOptions<
                    Awaited<
                        ReturnType<
                            typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                        >
                    >,
                    TError,
                    TData
                >
            >;
            axios?: AxiosRequestConfig;
        }
    ) => {
        const { query: queryOptions, axios: axiosOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetRisksRiskDirectoryIdNodesNodeIdActivityLogQueryKey(
                riskDirectoryId,
                nodeId,
                params
            );

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
            >
        > = ({ signal }) =>
            getRisksRiskDirectoryIdNodesNodeIdActivityLog(
                riskDirectoryId,
                nodeId,
                params,
                { signal, ...axiosOptions }
            );

        return {
            queryKey,
            queryFn,
            ...queryOptions,
        } as UseSuspenseQueryOptions<
            Awaited<
                ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
            >,
            TError,
            TData
        > & { queryKey: DataTag<QueryKey, TData, TError> };
    };

export type GetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspenseQueryResult =
    NonNullable<
        Awaited<
            ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
        >
    >;
export type GetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspenseQueryError =
    AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspense<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspense<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspense<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspense<
    TData = Awaited<
        ReturnType<typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog>
    >,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    nodeId: RiskDirectorySuperNodeId,
    params: GetRisksRiskDirectoryIdNodesNodeIdActivityLogParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRisksRiskDirectoryIdNodesNodeIdActivityLog
                    >
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetRisksRiskDirectoryIdNodesNodeIdActivityLogSuspenseQueryOptions(
            riskDirectoryId,
            nodeId,
            params,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getRisksRiskDirectoryIdNodes = (
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryNodeWithDetailsDto>> => {
    return axios.get(`/api/risks/${riskDirectoryId}/nodes`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetRisksRiskDirectoryIdNodesQueryKey = (
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams
) => {
    return [
        `/api/risks/${riskDirectoryId}/nodes`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetRisksRiskDirectoryIdNodesQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdNodesQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdNodes(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: riskDirectoryId !== null && riskDirectoryId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdNodesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
>;
export type GetRisksRiskDirectoryIdNodesQueryError = AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodes<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: undefined | GetRisksRiskDirectoryIdNodesParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodes<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodes<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodes<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdNodesQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksRiskDirectoryIdNodesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdNodesQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdNodes(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdNodesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>
>;
export type GetRisksRiskDirectoryIdNodesSuspenseQueryError =
    AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdNodesSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: undefined | GetRisksRiskDirectoryIdNodesParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdNodesSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdNodesSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdNodesParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdNodes>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdNodesSuspenseQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postRisksRiskDirectoryIdNodes = (
    riskDirectoryId: RiskDirectoryId,
    newRiskDirectoryNode: NewRiskDirectoryNode,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SingleRiskDirectoryNodeView>> => {
    return axios.post(
        `/api/risks/${riskDirectoryId}/nodes`,
        newRiskDirectoryNode,
        options
    );
};

export const getPostRisksRiskDirectoryIdNodesMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>,
        TError,
        { riskDirectoryId: RiskDirectoryId; data: NewRiskDirectoryNode },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: NewRiskDirectoryNode },
    TContext
> => {
    const mutationKey = ["postRisksRiskDirectoryIdNodes"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>,
        { riskDirectoryId: RiskDirectoryId; data: NewRiskDirectoryNode }
    > = (props) => {
        const { riskDirectoryId, data } = props ?? {};

        return postRisksRiskDirectoryIdNodes(
            riskDirectoryId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PostRisksRiskDirectoryIdNodesMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>
>;
export type PostRisksRiskDirectoryIdNodesMutationBody = NewRiskDirectoryNode;
export type PostRisksRiskDirectoryIdNodesMutationError = AxiosError<unknown>;

export const usePostRisksRiskDirectoryIdNodes = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>,
            TError,
            { riskDirectoryId: RiskDirectoryId; data: NewRiskDirectoryNode },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdNodes>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: NewRiskDirectoryNode },
    TContext
> => {
    return useMutation(
        getPostRisksRiskDirectoryIdNodesMutationOptions(options),
        queryClient
    );
};
export const patchRisksRiskDirectoryIdNodes = (
    riskDirectoryId: RiskDirectoryId,
    patchRisksRiskDirectoryIdNodesBody: PatchRisksRiskDirectoryIdNodesBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/risks/${riskDirectoryId}/nodes`,
        patchRisksRiskDirectoryIdNodesBody,
        options
    );
};

export const getPatchRisksRiskDirectoryIdNodesMutationOptions = <
    TError = AxiosError<MissingRequiredColumnsDetails>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>,
        TError,
        {
            riskDirectoryId: RiskDirectoryId;
            data: PatchRisksRiskDirectoryIdNodesBody;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        data: PatchRisksRiskDirectoryIdNodesBody;
    },
    TContext
> => {
    const mutationKey = ["patchRisksRiskDirectoryIdNodes"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>,
        {
            riskDirectoryId: RiskDirectoryId;
            data: PatchRisksRiskDirectoryIdNodesBody;
        }
    > = (props) => {
        const { riskDirectoryId, data } = props ?? {};

        return patchRisksRiskDirectoryIdNodes(
            riskDirectoryId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchRisksRiskDirectoryIdNodesMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>
>;
export type PatchRisksRiskDirectoryIdNodesMutationBody =
    PatchRisksRiskDirectoryIdNodesBody;
export type PatchRisksRiskDirectoryIdNodesMutationError =
    AxiosError<MissingRequiredColumnsDetails>;

export const usePatchRisksRiskDirectoryIdNodes = <
    TError = AxiosError<MissingRequiredColumnsDetails>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                data: PatchRisksRiskDirectoryIdNodesBody;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryIdNodes>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        data: PatchRisksRiskDirectoryIdNodesBody;
    },
    TContext
> => {
    return useMutation(
        getPatchRisksRiskDirectoryIdNodesMutationOptions(options),
        queryClient
    );
};
export const getRisksRiskDirectoryId = (
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryResourceDto>> => {
    return axios.get(`/api/risks/${riskDirectoryId}`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetRisksRiskDirectoryIdQueryKey = (
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams
) => {
    return [
        `/api/risks/${riskDirectoryId}`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetRisksRiskDirectoryIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
    > = ({ signal }) =>
        getRisksRiskDirectoryId(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: riskDirectoryId !== null && riskDirectoryId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
>;
export type GetRisksRiskDirectoryIdQueryError = AxiosError<unknown>;

export function useGetRisksRiskDirectoryId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: undefined | GetRisksRiskDirectoryIdParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryId<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksRiskDirectoryIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
    > = ({ signal }) =>
        getRisksRiskDirectoryId(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryId>>
>;
export type GetRisksRiskDirectoryIdSuspenseQueryError = AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: undefined | GetRisksRiskDirectoryIdParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdSuspenseQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteRisksRiskDirectoryId = (
    riskDirectoryId: RiskDirectoryId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/risks/${riskDirectoryId}`, options);
};

export const getDeleteRisksRiskDirectoryIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>,
        TError,
        { riskDirectoryId: RiskDirectoryId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId },
    TContext
> => {
    const mutationKey = ["deleteRisksRiskDirectoryId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>,
        { riskDirectoryId: RiskDirectoryId }
    > = (props) => {
        const { riskDirectoryId } = props ?? {};

        return deleteRisksRiskDirectoryId(riskDirectoryId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteRisksRiskDirectoryIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>
>;

export type DeleteRisksRiskDirectoryIdMutationError = AxiosError<unknown>;

export const useDeleteRisksRiskDirectoryId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>,
            TError,
            { riskDirectoryId: RiskDirectoryId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRisksRiskDirectoryId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId },
    TContext
> => {
    return useMutation(
        getDeleteRisksRiskDirectoryIdMutationOptions(options),
        queryClient
    );
};
export const patchRisksRiskDirectoryId = (
    riskDirectoryId: RiskDirectoryId,
    updatableRiskDirectory: UpdatableRiskDirectory,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryResourceDto>> => {
    return axios.patch(
        `/api/risks/${riskDirectoryId}`,
        updatableRiskDirectory,
        options
    );
};

export const getPatchRisksRiskDirectoryIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>,
        TError,
        { riskDirectoryId: RiskDirectoryId; data: UpdatableRiskDirectory },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: UpdatableRiskDirectory },
    TContext
> => {
    const mutationKey = ["patchRisksRiskDirectoryId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>,
        { riskDirectoryId: RiskDirectoryId; data: UpdatableRiskDirectory }
    > = (props) => {
        const { riskDirectoryId, data } = props ?? {};

        return patchRisksRiskDirectoryId(riskDirectoryId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchRisksRiskDirectoryIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>
>;
export type PatchRisksRiskDirectoryIdMutationBody = UpdatableRiskDirectory;
export type PatchRisksRiskDirectoryIdMutationError = AxiosError<unknown>;

export const usePatchRisksRiskDirectoryId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>,
            TError,
            { riskDirectoryId: RiskDirectoryId; data: UpdatableRiskDirectory },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchRisksRiskDirectoryId>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: UpdatableRiskDirectory },
    TContext
> => {
    return useMutation(
        getPatchRisksRiskDirectoryIdMutationOptions(options),
        queryClient
    );
};
export const postRisksRiskDirectoryIdAiInsights = (
    riskDirectoryId: RiskDirectoryId,
    params: PostRisksRiskDirectoryIdAiInsightsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskAiInsights>> => {
    return axios.post(`/api/risks/${riskDirectoryId}/ai-insights`, undefined, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostRisksRiskDirectoryIdAiInsightsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>,
        TError,
        {
            riskDirectoryId: RiskDirectoryId;
            params: PostRisksRiskDirectoryIdAiInsightsParams;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        params: PostRisksRiskDirectoryIdAiInsightsParams;
    },
    TContext
> => {
    const mutationKey = ["postRisksRiskDirectoryIdAiInsights"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>,
        {
            riskDirectoryId: RiskDirectoryId;
            params: PostRisksRiskDirectoryIdAiInsightsParams;
        }
    > = (props) => {
        const { riskDirectoryId, params } = props ?? {};

        return postRisksRiskDirectoryIdAiInsights(
            riskDirectoryId,
            params,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PostRisksRiskDirectoryIdAiInsightsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>
>;

export type PostRisksRiskDirectoryIdAiInsightsMutationError =
    AxiosError<unknown>;

export const usePostRisksRiskDirectoryIdAiInsights = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                params: PostRisksRiskDirectoryIdAiInsightsParams;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdAiInsights>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        params: PostRisksRiskDirectoryIdAiInsightsParams;
    },
    TContext
> => {
    return useMutation(
        getPostRisksRiskDirectoryIdAiInsightsMutationOptions(options),
        queryClient
    );
};
export const postRisksRiskDirectoryIdCopy = (
    riskDirectoryId: RiskDirectoryId,
    params: PostRisksRiskDirectoryIdCopyParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryView>> => {
    return axios.post(`/api/risks/${riskDirectoryId}/copy`, undefined, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostRisksRiskDirectoryIdCopyMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>,
        TError,
        {
            riskDirectoryId: RiskDirectoryId;
            params: PostRisksRiskDirectoryIdCopyParams;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        params: PostRisksRiskDirectoryIdCopyParams;
    },
    TContext
> => {
    const mutationKey = ["postRisksRiskDirectoryIdCopy"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>,
        {
            riskDirectoryId: RiskDirectoryId;
            params: PostRisksRiskDirectoryIdCopyParams;
        }
    > = (props) => {
        const { riskDirectoryId, params } = props ?? {};

        return postRisksRiskDirectoryIdCopy(
            riskDirectoryId,
            params,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PostRisksRiskDirectoryIdCopyMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>
>;

export type PostRisksRiskDirectoryIdCopyMutationError = AxiosError<unknown>;

export const usePostRisksRiskDirectoryIdCopy = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                params: PostRisksRiskDirectoryIdCopyParams;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postRisksRiskDirectoryIdCopy>>,
    TError,
    {
        riskDirectoryId: RiskDirectoryId;
        params: PostRisksRiskDirectoryIdCopyParams;
    },
    TContext
> => {
    return useMutation(
        getPostRisksRiskDirectoryIdCopyMutationOptions(options),
        queryClient
    );
};
export const getRisksRiskDirectoryIdInsights = (
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ArrayOfAssessmentDto>> => {
    return axios.get(`/api/risks/${riskDirectoryId}/insights`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetRisksRiskDirectoryIdInsightsQueryKey = (
    riskDirectoryId: RiskDirectoryId,
    params?: GetRisksRiskDirectoryIdInsightsParams
) => {
    return [
        `/api/risks/${riskDirectoryId}/insights`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetRisksRiskDirectoryIdInsightsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdInsightsQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdInsights(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: riskDirectoryId !== null && riskDirectoryId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdInsightsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
>;
export type GetRisksRiskDirectoryIdInsightsQueryError = AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdInsights<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdInsights<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                    TError,
                    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdInsights<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdInsights<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdInsightsQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksRiskDirectoryIdInsightsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetRisksRiskDirectoryIdInsightsQueryKey(riskDirectoryId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
    > = ({ signal }) =>
        getRisksRiskDirectoryIdInsights(riskDirectoryId, params, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksRiskDirectoryIdInsightsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>
>;
export type GetRisksRiskDirectoryIdInsightsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetRisksRiskDirectoryIdInsightsSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdInsightsSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksRiskDirectoryIdInsightsSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksRiskDirectoryIdInsightsSuspense<
    TData = Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
    TError = AxiosError<unknown>,
>(
    riskDirectoryId: RiskDirectoryId,
    params: GetRisksRiskDirectoryIdInsightsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisksRiskDirectoryIdInsights>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksRiskDirectoryIdInsightsSuspenseQueryOptions(
        riskDirectoryId,
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const putRisksRiskDirectoryIdStructure = (
    riskDirectoryId: RiskDirectoryId,
    updatedRiskDirectoryStructure: UpdatedRiskDirectoryStructure,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryResource>> => {
    return axios.put(
        `/api/risks/${riskDirectoryId}/structure`,
        updatedRiskDirectoryStructure,
        options
    );
};

export const getPutRisksRiskDirectoryIdStructureMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>,
        TError,
        {
            riskDirectoryId: RiskDirectoryId;
            data: UpdatedRiskDirectoryStructure;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: UpdatedRiskDirectoryStructure },
    TContext
> => {
    const mutationKey = ["putRisksRiskDirectoryIdStructure"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>,
        {
            riskDirectoryId: RiskDirectoryId;
            data: UpdatedRiskDirectoryStructure;
        }
    > = (props) => {
        const { riskDirectoryId, data } = props ?? {};

        return putRisksRiskDirectoryIdStructure(
            riskDirectoryId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PutRisksRiskDirectoryIdStructureMutationResult = NonNullable<
    Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>
>;
export type PutRisksRiskDirectoryIdStructureMutationBody =
    UpdatedRiskDirectoryStructure;
export type PutRisksRiskDirectoryIdStructureMutationError = AxiosError<unknown>;

export const usePutRisksRiskDirectoryIdStructure = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>,
            TError,
            {
                riskDirectoryId: RiskDirectoryId;
                data: UpdatedRiskDirectoryStructure;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof putRisksRiskDirectoryIdStructure>>,
    TError,
    { riskDirectoryId: RiskDirectoryId; data: UpdatedRiskDirectoryStructure },
    TContext
> => {
    return useMutation(
        getPutRisksRiskDirectoryIdStructureMutationOptions(options),
        queryClient
    );
};
export const getRisks = (
    params?: GetRisksParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SimpleRiskDirectoryListDto>> => {
    return axios.get(`/api/risks`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetRisksQueryKey = (params?: GetRisksParams) => {
    return [`/api/risks`, ...(params ? [params] : [])] as const;
};

export const getGetRisksQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRisks>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRisksQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRisks>>> = ({
        signal,
    }) => getRisks(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRisks>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisks>>
>;
export type GetRisksQueryError = AxiosError<unknown>;

export function useGetRisks<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetRisksParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRisks>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisks>>,
                    TError,
                    Awaited<ReturnType<typeof getRisks>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisks<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRisks>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRisks>>,
                    TError,
                    Awaited<ReturnType<typeof getRisks>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisks<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRisks>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisks<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRisks>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetRisksSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetRisksQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRisks>>> = ({
        signal,
    }) => getRisks(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getRisks>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRisksSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRisks>>
>;
export type GetRisksSuspenseQueryError = AxiosError<unknown>;

export function useGetRisksSuspense<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetRisksParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksSuspense<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRisksSuspense<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetRisksSuspense<
    TData = Awaited<ReturnType<typeof getRisks>>,
    TError = AxiosError<unknown>,
>(
    params?: GetRisksParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getRisks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetRisksSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postRisks = (
    createRiskDirectory: CreateRiskDirectory,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryView>> => {
    return axios.post(`/api/risks`, createRiskDirectory, options);
};

export const getPostRisksMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRisks>>,
        TError,
        { data: CreateRiskDirectory },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRisks>>,
    TError,
    { data: CreateRiskDirectory },
    TContext
> => {
    const mutationKey = ["postRisks"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRisks>>,
        { data: CreateRiskDirectory }
    > = (props) => {
        const { data } = props ?? {};

        return postRisks(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostRisksMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRisks>>
>;
export type PostRisksMutationBody = CreateRiskDirectory;
export type PostRisksMutationError = AxiosError<unknown>;

export const usePostRisks = <TError = AxiosError<unknown>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRisks>>,
            TError,
            { data: CreateRiskDirectory },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postRisks>>,
    TError,
    { data: CreateRiskDirectory },
    TContext
> => {
    return useMutation(getPostRisksMutationOptions(options), queryClient);
};
